import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {config} from "./config";

class Graph extends React.Component {
  render() {
    let cheapest = this.props.data.reduce((min, g) => g[1] < min[1] ? [g[0], g[1]] : min, [this.props.data[0][0], this.props.data[0][1]]);
    let displayData = this.props.data.map(d => {
      var rObj = {};
      rObj["name"] = d[0];
      rObj["y"] = d[1];
      rObj["color"] = (cheapest[0] === d[0]) ? '#00AF43' : '#00584D';
      return rObj;
    });
    let dataValues = displayData.map(d => d.y);

    const options = {
      chart: {
        type: 'column',
        style: {
          fontFamily: config.css.defaultFontFamily,
          fontSize: "1.5rem",
          color: "#000000"
        },
        spacingBottom: 25,
        spacingTop: 25,
        spacingLeft: 25,
        spacingRight: 25,
        marginTop: 65,
      },
      credits: {
        enabled: false
      },
      title: {
        text: this.props.title,
        align: 'left',
        style: {
          fontFamily: config.css.defaultFontFamily,
          fontSize: '18px',
          fontWeight: config.css.fontWeightHeading,
        }
      },
      xAxis: {
        type: 'category',
        labels: {
          style: {
            fontFamily: config.css.defaultFontFamily,
            fontSize: '12px',
            color: "#000000"
          },
        },
      },
      yAxis: {
        labels: {
          style: {
            fontFamily: config.css.defaultFontFamily,
            fontSize: '11px',
            color: "#000000"
          },
          formatter: function() {
            if (dataValues.some(e => e > 1E9)) {
              return (this.value / 1000000000) + 'mrd';
            } else if (dataValues.some(e => e > 1E6)) {
              return (this.value / 1000000) + 'M';
            }
            return this.value / 1000 + 't';
          },
        },
        title: {
          align: 'high',
          text: 'Euroa',
          style: {
            fontFamily: config.css.defaultFontFamily,
            fontSize: '14px',
            color: "#000000"
          },
        }
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        formatter: function () {
            return this.point.name + '<br><b>' + this.y.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1 ") + ' €</b>';
        }
      },
      plotOptions: {
        column: {
          maxPointWidth: 18,
        }
      },
      series: [{
        data: displayData
      }]
    }

    return (
      <HighchartsReact highcharts={Highcharts} options={options} />
    );
  }
}

export default Graph;
